<template>
  <!-- Komponent wyświetla widok aktywnego filtra grupowania (GROUP BY) -->
  <div v-if="store.filters.groupBy" class="filter d-flex flex-column">
    <!-- Nagłówek z nazwą grupowania i ikoną kosza do usuwania filtra -->
    <h5 class="margin-0">
      {{ t('division-into') }}
      <!-- Ikona kosza do usuwania filtra -->
      <span class="icon-trash" @click="removeFilter()" role="button"></span>
    </h5>
    <!-- Widok szczegółowy wybranego filtra grupowania -->
    <div class="info collapse show" id="groupByFilterView">
      <!-- Jeśli filtr groupBy istnieje, pokazujemy jego opis -->
      <p v-if="store.filters.groupBy" class="margin-0">
        {{ store.groupBy[store.filters.groupBy] }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  // Oczekujemy obiektu store przekazanego jako prop
  props: {
    store: { required: true },
  },
  name: "GroupByFilterView",
  methods: {
    /**
     * Usuwa filtr grupowania po kliknięciu w ikonę kosza
     */
    removeFilter() {
      this.store.removeItem("groupBy");
    },
  },
};
</script>
<style scoped>
.filter {
  width: 100%;
}

.filter h5 {
  /* margin: 0; */
  padding: 10px 20px;
  background-color: white;
  position: relative;
  background: white url("../../assets/h-filter-bg.png") repeat-y right top;
}
.info {
  font-size: 12px;
  padding: 12px 20px;
  border-bottom: 1px solid #bbbbbb;
}
.info p {
  font-size: 12px;
  /* margin: 0; */
}
.icon-trash {
  background: url("../../assets/icons/trash.svg") no-repeat left top;
  width: 15px;
  height: 17px;
  position: absolute;
  cursor: pointer;
  top: 11px;
  right: 10px;
}
.icon-collapse {
  background: url("../../assets/icons/zwin.png") no-repeat left top;
  width: 19px;
  height: 19px;
  position: absolute;
  cursor: pointer;
  right: 20px;
}
.collapsed.icon-collapse {
  background: url("../../assets/icons/rozwin.png") no-repeat left top;
}
</style>
